var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 537,
    viewBox: "0 0 494 684",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152 684a342 342 0 100-684 342 342 0 000 684z",
    fill: "#285680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152 0C104 0 59 10 18 27 16 38 7 58 7 64c1 0 87-88 76-29-6 38-76 38-73 77 73 28 99-55 161-55 21 0 75-33 85-26 41 27-10 123-41 91-31-30-74 11-72 58 16 1 23-44 37-29 15 16 10 50-12 58s-107-58-86-8c23 55-69 97 24 75 44-10 29 23 50 39 24 19 14-26 32-19 26 10-5 36 36 17 48-22 30 12 45 34 27 42 95 82 130 27 9-13 3-116 56-47 33 44 22-51 27-77A342 342 0 00152 0z",
    fill: "#24AE5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198 496l-63-47-42 2-44-14-34-24-78 18-32 16-36 48 13 56 11 14 66 31 45 6 26 54 1 6a341 341 0 00206 11l9-53 41-33 17-53-85-1-21-37z",
    fill: "#FAC176"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164 625c-13-1-60-16-71-35-11-20-34-53-35-48-1 4-108-32-181-58l-8 11 13 56 11 14 66 31 45 6 26 54 1 6a341 341 0 00206 11l7-40-21-8c-33-13-46 1-59 0z",
    fill: "#88C057"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287 587l17-53-85-1-21-37-63-47-42 2-44-14-34-24-78 18-32 16-28 37c73 26 180 62 181 58 1-5 24 28 35 48 11 19 58 34 71 35s26-13 59 0l21 8 2-13 41-33z",
    fill: "#88C057"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M281 25l-4 75-66 66s62 88 66 98c4 11 55 23 66 17 10-6 49-39 66-17 11 16 10 30 17 40 5 0 11 3 18 11l34 9c4-21 1-59 4-74A343 343 0 00281 25z",
    fill: "#24AE5F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M321 45l-4 73-47 47s44 63 47 71c3 7 40 16 47 12 8-5 36-28 47-12 12 16 5 29 24 35l45 12c0-14 0-26 2-33-25-87-83-161-161-205z",
    fill: "#1F9451"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.8944888263b02620f2bbd3b2b094167d.svg";
export { ForwardRef as ReactComponent };